import { PropertyFilterProps } from '@amzn/awsui-components-console/property-filter';

export const DEFAULT_PAGE_SIZE = 50;

export const FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
	{
		key: 'status',
		propertyLabel: 'Status',
		groupValuesLabel: 'Status values',
		operators: ['='],
	},
	{
		key: 'subTaskExecutionName',
		propertyLabel: 'Sub Task Name',
		groupValuesLabel: 'Sub Task Name values',
		operators: ['='],
	},
];

export const CONTENT_SELECTOR_OPTIONS = [
	{
		label: 'Select Visible Columns',
		options: [
			{ id: 'TaskExecutionId', label: 'Task Execution Id', visible: true },
			{ id: 'TaskRunId', label: 'Task Run Id', visible: true },
			{ id: 'NotificationId', label: 'Notification Id', visible: true },
			{
				id: 'SubTaskExecutionId',
				label: 'Sub Task Execution Id',
				visible: true,
			},
			{ id: 'SubTaskExecutionName', label: 'Sub Task Name', visible: true },
			{ id: 'SubTaskStatus', label: 'Sub Task Status', visible: true },
			{ id: 'AttemptNo', label: 'Number Of Attempts', visible: false },
			{ id: 'Last Updated Time', label: 'Last Updated Time', visible: false },
		],
	},
];

export const PAGE_SELECTOR_OPTIONS = [
	{ value: 50, label: '50 tasks' },
	{ value: 75, label: '75 tasks' },
	{ value: 100, label: '100 tasks' },
];

export const COLLECTION_PREFERENCES = {
	title: 'Preferences',
	confirmLabel: 'Confirm',
	cancelLabel: 'Cancel',
	pageSizePreference: {
		title: 'Select page size',
		options: PAGE_SELECTOR_OPTIONS,
	},
	visibleContentPreference: {
		title: 'Select Columns',
		options: CONTENT_SELECTOR_OPTIONS,
	},
	wrapLinesPreference: {
		label: 'Wrap lines',
		description: 'Select to see all the text and wrap the lines',
	},
	stripedRowsPreference: {
		label: 'Striped rows',
		description: 'Select to add alternating shaded rows',
	},
};

export const VISIBLE_CONTENT = [
	'SubTaskExecutionName',
	'NotificationId',
	'SubTaskStatus',
];

export const getSubTaskExecutionDataURL = (workflowId, workflowExecutionId, taskExecutionId) =>
	`/workflows/${workflowId}/executions/${workflowExecutionId}/tasks/${taskExecutionId}/subtasks`;